<template>
  <section id="broadcastView" class="statv_container">
    <h2 class="disabled"> 채널소개 </h2>
    <article class="section background1">
      <!-- <h4 class="disabled"> 채널 슬로건 </h4>
      <div class="text_box statv_wrapper display-none-mobile">
        <span class="text1"> 다양한 K콘텐츠를 선보이는 <br> 종합 엔터 채널
          <img src="~@/assets/image/broadcast/SPOTV_K.png" />
        </span>
        <span class="text2">
          <img src="~@/assets/image/broadcast/sub_text.png" />
        </span>
      </div> -->
    </article>
  </section>
</template>
<script>
import Utils from "@/helpers/utils.js";

export default {
  name: "broadcast",
  data() {
    return {
      isMobile: false,
    }
  },
  created() {

  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {

  },
}
</script>
<style lang="less">
#broadcastView {
  cursor: default;
  .section {
    width: 100%;
    height: 1080px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 1920px 100%;
    display: flex;
    align-items: center;
    .text_box {
        color: #FFFFFF;
        position: absolute;
        display: block;
        align-items: center;

        & .text1 {
          display: block;
          font-size: 66px;
          font-weight: 900;
          padding-bottom: 58px;
          img {
            width: 226px;
            height: 66px;
            position: absolute;
            margin-top: 3px;
            margin-left: 30px;
          }
        }
        & .text2 {
          display: block;
          img {
            width: 554px;
            height: 32px;
          }
        }
    }
    &.background1 {
      background-image: url("~@/assets/image/broadcast/ch_img01.png");
    }
  }
}

.m #broadcastView {
  .section {
    width: 100%;
    height: 1360px;
    background-size: 765px 100%;

    .display-none-mobile {
      display: none;
    }
    .text_box {
      font-size: 46px;
    }
    &.background1 {
      background-image: url("~@/assets/image/broadcast/ch_img01_m.png");
      .text1::after {
        width: 453px;
        height: 6px;
      }
    }
  }
}
</style>
